import { StyleObject } from 'styletron-react'

// The four border colors alone, for states that only recolor a border the
// component already draws.
export const borderColors = (color: string): StyleObject => ({
  borderTopColor: color,
  borderRightColor: color,
  borderBottomColor: color,
  borderLeftColor: color,
})

// A 1px solid border expressed as LONGHAND props (width/style/color per side),
// for use inside a uikit `overrides.BaseButton.style` object. uikit's BaseButton
// resets borders with longhand, so adding a `border` shorthand alongside trips
// Styletron's "mixing shorthand and longhand … unsupported with atomic
// rendering" warning. Returning a typed StyleObject also lets the 'solid'
// literals check without an `as const` assertion. Centralized here so the
// workaround lives in one place (a future uikit fix touches a single spot).
export const solidBorder = (color: string): StyleObject => ({
  borderTopWidth: '1px',
  borderRightWidth: '1px',
  borderBottomWidth: '1px',
  borderLeftWidth: '1px',
  borderTopStyle: 'solid',
  borderRightStyle: 'solid',
  borderBottomStyle: 'solid',
  borderLeftStyle: 'solid',
  ...borderColors(color),
})
